


























import {Component, Prop, Vue} from 'vue-property-decorator'
import UserStore from "@/store/modules/UserStore";
import {Util} from "@/_global/utils";

@Component({
    components: {
    },
})
export default class HeaderBar extends Vue {
    @Prop() private msg!: string

    private isShow:boolean = false;

    get userName() {
        return UserStore.user.username;
    }

    get companyName() {
        return UserStore.user.head_name;
    }

    get deliousTopPageUrl(){
        return Util.deliouTopPageUrl();
    }

    private mounted():void {
        document.addEventListener('click', this.onClickDocument);
    }

    private destroyed():void {
        document.removeEventListener('click', this.onClickDocument);
    }

    private toggle(e:any): void {
        this.isShow = !this.isShow;
    }

    private close(): void {
        this.isShow = false;
    }

    private onClickDocument(e:any) {
        if (! e.target.parentNode.classList.contains('drop-down')) {
            this.close();
        }
    }
}
